module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/regular-task-097b2cd39649b6dd9289f642f9a3daba.svg";